import { provideRouter, RouterConfig } from '@angular/router';

import {LoginComponent} from './AuthModule/login.component';
import {HomeComponent} from './Home/home.component';
import {ContentComponent} from './Home/content/content.component';
import {PersonComponent} from './Home/person/person.component';
import {PersonlocationComponent} from './Home/personlocation/personlocation.component';
import {PersoncaptionComponent} from './Home/personcaption/personcaption.component';
import {HomepostComponent} from './Home/homepost/homepost.component';
import {DiscoverpostComponent} from './Home/discoverpost/discoverpost.component';
import {DiscoverComponent} from './Home/discover/discover.component';
import {ProfileComponent} from './Home/profile/profile.component';
import {ProfileeditComponent} from './Home/profileedit/profile-edit.component';
import {ResetpasswordComponent} from './Resetpassword/reset.component';
import {PrivacyComponent} from './Privacy/privacy.component';
import {TermsComponent} from './Terms/terms.component';
import {EulaComponent} from './eula/eula.component';
import {PageComponent} from './Home/pageloading.component';

export const routes: RouterConfig = [
  { path: '', redirectTo: 'login', terminal: true },
  { path: 'login', component: LoginComponent },
  { path: 'reset/:reset_token', component: ResetpasswordComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'eula', component: EulaComponent },
  { path: 'terms', component: TermsComponent },
  {
    path: 'home', component: HomeComponent,
    children: [
      { path: '', component: ContentComponent },
      { path: 'homepost/:name/:id', component: HomepostComponent },
      { path: 'person/:name', component: PersonComponent },
      { path: 'personlocation/:name', component: PersonlocationComponent },
      { path: 'personcaption/:name', component: PersoncaptionComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'profile-edit', component: ProfileeditComponent },
      { path: 'discover', component: DiscoverComponent },
       { path: 'discoverpost', component: DiscoverpostComponent }
      // { path: 'reset', component: ResetpasswordComponent }
    ]
  },
  { path: 'page', component: PageComponent },
];

export const APP_ROUTER_PROVIDERS = [
  provideRouter(routes)
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/app.routes.ts
 **/